<!-- Modal backdrop -->
<div class="modal-backdrop" [class.show]="showModal" (click)="closeModal()"></div>

<!-- Sign out modal -->
<div class="custom-modal" [class.show]="showModal" (click)="closeModal()">
  <div class="modal-dialog" (click)="stopPropagation($event)">
    <div class="modal-content">
      <div class="modal-body">
        <div class="logout-icon-container">
          <div class="logout-icon">
            <i class="ri-logout-box-line" style="color: var(--color-red-normal);"></i>
          </div>
        </div>
        <h5 class="modal-title-custom">Log Out</h5>
        <p class="modal-text">Are you sure you want to Sign Out the dashboard?</p>

        <div class="modal-footer-custom">
          <button type="button" class="btn btn-cancel" (click)="closeModal()">Cancel</button>
          <button type="button" class="btn btn-sign-out" (click)="signOut()">Yes, Sign Out</button>
        </div>
      </div>
    </div>
  </div>
</div>
